<template>
    <div>
        <div class="form-group row align-items-center">
            <label class="col-form-label text-md-right col-md-2">Тип</label>
            <div class="col-md-9">
                <multiselect
                    v-model="type"
                    :options="['All Report', 'Startup It Report']"
                    :multiple="false"
                />
            </div>
        </div>

        <AllReportComponent
            v-if="type === 'All Report'"
            :groups="groups"
        ></AllReportComponent>

        <StartupitReportComponent
            v-if="type === 'Startup It Report'"
            :groups="groups"
        ></StartupitReportComponent>

    </div>
</template>

<script>

import AllReportComponent from "./AllReportComponent";
import StartupitReportComponent from "./StartupitReportComponent";

export default {
    components: {AllReportComponent, StartupitReportComponent},
    props: [
        'gradebook_groups',
        'cgroups',
        'groups',
        'teacher'
    ],
    name: "QuestionnaireComponent",
    data() {
        return {
            type: null,
        }
    },
}
</script>
<style scoped>
    .load_block {
        opacity: 0.3;
        pointer-events: none;
    }
    .load_transition {
        transition: 0.2s;
    }
    .form-group{
        margin-bottom: 15px;
    }
</style>
